import TokenizedSequencesContract from 'decentralized/contracts/TokenizedSequencesContract.js';
import {lstorage} from 'utils/lstorage.js';
import accounts from 'accounts/Accounts.js';
import ethereum from 'decentralized/ethereum.js';
import {TokenizedSequenceEdited} from 'decentralized/EthereumEvents.js';
import BackendQuery from 'decentralized/BackendQuery.js';

const contract = new TokenizedSequencesContract();
const contractAddress = contract.contractAddress;

export const getProjects = async (searchTerm, filterMine, starred, favorited, searchTag, useLocal=true, guildId, user) => {
    searchTerm = searchTerm.toLowerCase();

    let results = [];
    let guildIds = guildId ? [guildId] : [0, ...(await ethereum.guilds.getGuildsForUser()).map(x => x.guildId)];
    results = await getProjectsFromServer(filterMine, starred, favorited, searchTerm, searchTag, guildIds, user);

    if (!favorited && !starred && !searchTag && !guildId) {
        let encResults = [];
        let privateSequences = await ethereum.getPrivateSequences();
        if (!privateSequences || (guildId !== 0 && !filterMine)) {
            privateSequences = [];
        }
        encResults = [... privateSequences];
        if (searchTerm !== "") {
            results = [... results, ... encResults.filter(
                x => x.title && x.title.toLowerCase().includes(searchTerm.toLowerCase()))];
        } else {
            results = [... results, ... encResults];
        }
    }

    let localProjects = lstorage.getItem("sequences");
    let ids = new Set(results.map(x => x.newSequence));
    if (useLocal && localProjects && guildId === 0 && searchTerm === "" && filterMine && !starred && !favorited) {
        localProjects = JSON.parse(localProjects);
        let user = await accounts.getAccount();
        for (let project of localProjects) {
            if (ids.has(project.hash)) {
                continue;
            }
            project.user = user;
            project.isLocal = true;
            project.newSequence = project.hash;
            if (project.title && project.title !== "") {
                results.push(project);
            }
        }
    }
    results.sort((a, b) => b.blockNumber - a.blockNumber);

    return results;
};

const getProjectsFromServer = (filterMine, starred, favorited, searchTerm, searchTag='', guildIds=[0], user) => {
    return new Promise(async (resolve, reject) => {
        if (filterMine) {
            user = await accounts.getAccount();
        }
        if (favorited) {
            favorited = await accounts.getAccount();
            favorited = favorited.toLowerCase();
        }
        let query = {searchTerm, starred, favorited, searchTag, guildIds, user};
        if (user) {
            query["user"] = user.toLowerCase();
        }
        if (filterMine) {
            query.filterMine = true;
        }

        fetch('/projects/' , {
            method: 'POST',
            body: JSON.stringify(query),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(resp => resp.json())
            .then(resp => {
                resolve(resp);
            });
    });
}
